import React, { useState } from "react";
import DrawerTitle from "../Drawer/DrawerTitle";
import { AllTabType, TabType } from "src/types/GlobalInterfaces";
import PrescriptionsSection from "./ManageDoctor/PrescriptionsSection";
import ReportsScreenSection from "./ManageDoctor/ReportsScreenSection";
import SingleChat from "src/Pages/ChatApp/SingleChat";
import TabsSlideContainer from "../GlobalComponents/Widget/TabsSlideContainer";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";

const ManageDoctorScreen = ({
  setActiveTab,
  currentDoctor,
  setCurrentDoctor,
  defaultTab,
}: {
  onBack: () => void;
  setActiveTab: (tab: AllTabType) => void;
  currentDoctor: any;
  setCurrentDoctor: (doctor: any) => void;
  onClose?: () => void;
  defaultTab?: "Prescriptions" | "Chat" | "Reports";
}) => {
  const { latestChat } = useSelector((state: RootState) => state.chat);
  const [activePrescription, setActivePrescription] = useState<any>(null);
  let tabs: TabType[] = [
    {
      name: "Prescriptions",
      count: currentDoctor?.redNotified === false ? 1 : 0,
    },
    {
      name: "Chat",
      count:
        latestChat?.find((item) => item?._id === currentDoctor?.id)?.unRead ||
        0,
    },
    {
      name: "Reports",
      count: 0,
    },
  ];

  const [acTab, setAcTab] = useState<TabType>(
    defaultTab
      ? (tabs.find((item) => item.name === defaultTab) as TabType)
      : (tabs[0] as TabType)
  );

  return (
    <div className="w-full flex flex-col side-bar-gap min-h-screen h-fit">
      <DrawerTitle
        title={"Manage"}
        backBtn
        onBack={() => {
          if (activePrescription) {
            setActivePrescription(null);
          } else {
            setActiveTab("MyDoctor");
          }
        }}
      />
      {/* Navigation Tabs */}
      <div className="px-2 2xl:px-3 w-full relative flex gap-2 overflow-x-auto tab-height-adjustment-2  scroll-hide">
        <TabsSlideContainer
          tabs={tabs}
          activeTab={acTab}
          onChange={(tab) => setAcTab(tab)}
          showCount={false}
        />
      </div>

      {/* Doctor Cards */}
      {acTab.name === "Prescriptions" && (
        <div className="px-2 xl:px-3 pb-2 xl:pb-3 w-full">
          <PrescriptionsSection
            currentDoctor={currentDoctor}
            onBack={() => setActiveTab("MyDoctor")}
            setActivePrescription={setActivePrescription}
            activePrescription={activePrescription}
            setCurrentDoctor={setCurrentDoctor}
          />
        </div>
      )}
      {acTab.name === "Chat" && (
        <div className="px-2 xl:px-3 pb-2 xl:pb-3 flex-1">
          <div className="w-full h-full box-design overflow-hidden">
            <SingleChat isCustomerSide={true} doctorID={currentDoctor.id} />
          </div>
        </div>
      )}
      {acTab.name === "Reports" && (
        <div className="px-2 xl:px-3 pb-2 xl:pb-3 w-full">
          <ReportsScreenSection currentDoctor={currentDoctor} />
        </div>
      )}
    </div>
  );
};

export default ManageDoctorScreen;
